export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8553.0f6c0758.jpg";